// extracted by mini-css-extract-plugin
module.exports = {"item":"Parameter-module--item--3ZXlF","padded":"Parameter-module--padded--1K5Kq","description":"Parameter-module--description--386l6","indent":"Parameter-module--indent--GOBhv"};